import Compressor from 'compressorjs';

export const CompressImageFile = (file, maxSizeMB = 2, context = '') => {
     return new Promise((resolve, reject) => {
          console.log(`Starting compression for ${context || 'file'} (${(file.size / (1024 * 1024)).toFixed(2)}MB)`);

          // Calculate quality based on file size
          // For larger files, use lower quality to get better compression
          const fileSize = file.size / (1024 * 1024);
          let quality = 0.8;

          if (fileSize > 5) quality = 0.6;
          else if (fileSize > 3) quality = 0.7;

          // Create timestamp to track performance
          const startTime = Date.now();

          new Compressor(file, {
               quality,
               maxWidth: 1920,
               maxHeight: 1920,
               convertSize: 1000000, // Convert to JPEG if > ~1MB
               success(result) {
                    const endTime = Date.now();
                    const compressedSize = result.size / (1024 * 1024);
                    console.log(`✅ Compression complete for ${context || 'file'}: 
                   - Original: ${fileSize.toFixed(2)}MB
                   - Compressed: ${compressedSize.toFixed(2)}MB 
                   - Reduction: ${((1 - (compressedSize / fileSize)) * 100).toFixed(1)}% 
                   - Time: ${(endTime - startTime)}ms`);

                    // If still too large, try harder compression
                    if (compressedSize > maxSizeMB && compressedSize < fileSize) {
                         console.log(`File still too large (${compressedSize.toFixed(2)}MB), compressing further...`);

                         // Second pass with more aggressive settings
                         new Compressor(result, {
                              quality: Math.max(0.5, quality - 0.2),
                              maxWidth: 1600,
                              maxHeight: 1600,
                              success(finalResult) {
                                   const finalSize = finalResult.size / (1024 * 1024);
                                   console.log(`Second pass complete: ${finalSize.toFixed(2)}MB`);
                                   resolve(finalResult);
                              },
                              error(err) {
                                   console.error(`Second compression pass failed for ${context || 'file'}:`, err);
                                   // Fallback to first compression result
                                   resolve(result);
                              }
                         });
                    } else {
                         resolve(result);
                    }
               },
               error(err) {
                    console.error(`Compression failed for ${context || 'file'}:`, err);
                    // Fallback to original file
                    reject(new Error(`Image compression failed: ${err.message}`));
               },
          });
     });
};